


























import { Component } from 'vue-property-decorator';
import AbstractDisplayField from './abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';

@Component({
  name: 'bpc-display-subscription-name',
  components: {},
})
export default class DisplaySubscriptionName extends mixins(AbstractDisplayField) {
  withDetails = this.fieldConfig.withDetails || false;
  detailsField = this.fieldConfig.detailsField || null;

  get details() {
    return this.item ? this.item[this.detailsField] : null;
  }

  get valueLabel(): string {
    const item = this.fieldConfig.valueToLabel?.find(item => item.value === this.value);

    return item?.label || item?.text || this.value;
  }

  get isRecrediting() {
    return !!this.item.recredit_subscription_id;
  }

  get recreditText(): string {
    return this.$t('subscriptions.recrediting_subscription_help_text') as string;
  }
}
